<template>
    <!--
        作者：bbc_team
        时间：2023-06-08
        描述：超链接选择-产品
    -->
    <div class="marketing-box">
        <el-tabs v-model="activeTab">
            <el-tab-pane label="详情" name="detail"></el-tab-pane>
        </el-tabs>

        <div v-if="activeTab == 'detail'" v-loading="loading" class="goods-list">
            <!--搜索表单-->
            <div class="common-seach-wrap">
                <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
                    <el-form-item label="商品名称"><el-input v-model="searchForm.goods_name" size="small" placeholder="请输入商品名称"></el-input></el-form-item>
                    <el-form-item>
                        <el-button size="small" icon="el-icon-search" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <!--内容-->
            <div class="goods-content">
                <div class="table-wrap setlink-goods-table">
                    <el-table size="mini" :data="tableData" border style="width: 100%">
                        <el-table-column prop="goods_name" label="产品">
                            <template slot-scope="scope">
                                <div class="goods-info">
                                    <div class="pic"><img v-img-url="scope.row.image[0].file_path" alt=""/></div>
                                    <div class="info">
                                        <div class="name text-ellipsis">{{ scope.row.goods_name }}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="goods_price" label="价格" width="100">
                            <template slot-scope="scope">
                                <span class="red">{{ scope.row.goods_price }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="80">
                            <template slot-scope="scope">
                                <el-button size="mini" @click="changeFunc(scope.row)">选择</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import GoodsApi from "@/api/goods.js";
    export default {
        data() {
            return {
                /*是否正在加载*/
                loading: true,
                /*tab切换选择中值*/
                activeTab: "detail",
                /*产品类别列表*/
                categoryList: [],
                /*当前选中*/
                categoryActive: [],
                /*搜索表单对象*/
                searchForm: {
                    goods_name: ""
                },
                /*产品数据表*/
                tableData: [],
                /*一页多少条*/
                pageSize: 5,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*选中的页面值*/
                activePage: null
            };
        },
        watch: {
            activeTab: function(n, o) {
                if (n != o) {
                    this.tableData = [];
                    if (n == "detail") {
                        this.getData();
                    }
                }
            }
        },
        created() {
            /*获取产品类别*/
            this.getData();
        },
        methods: {
            /*选择第几页*/
            handleCurrentChange(val) {
                let self = this;
                self.curPage = val;
                self.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.curPage = 0;
                this.getData();
            },

            /*获取列表*/
            getData() {
                let self = this;
                self.loading = true;
                let Params = {};
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                Params.goods_name = self.searchForm.goods_name;
                GoodsApi.goodsList(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                        if (self.curPage == 1 && self.tableData.length > 0) {
                            self.changeFunc(self.tableData[0]);
                        }
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*搜索查询*/
            onSubmit() {
                this.curPage = 0;
                this.getData();
            },

            /*选中的值*/
            changeFunc(e) {
                let obj = {};
                if (this.activeTab == "detail") {
                    obj.name = e.goods_name;
                    obj.url = "pages/goods/detail/detail?goods_id=" + e.goods_id;
                    obj.type = "商品详情";
                }

                this.$emit("changeData", obj);
            }
        }
    };
</script>
<style scoped>
    .table-wrap.setlink-goods-table .goods-info .pic {
        width: 20px;
        height: 20px;
        background: #ffffff;
    }

    .table-wrap.setlink-goods-table .goods-info .pic img {
        width: 20px;
        height: 20px;
    }

    .marketing-box .el-tree-node__content {
        height: 30px;
    }

    .marketing-box .el-tree-node__content {
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/setlink/part/Goods.vue